export default __webpack_public_path__ + "static/media/exercise_1.7094fa7e.jpg";